import ModalReservado from '../ModalReservado';
import ModalTerceiro from '../ModalTerceiro';
import verificarDisponibilidadeOnibus from '../../utils/verificarDisponibilidadeOnibus';
import api3001 from '../../services/api3001';
import Swal from "sweetalert2";
import React from 'react';
import styled from 'styled-components';

const Select = styled.select`
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  border-radius: 8px;
  font-size: 0.8rem;
  background-color: #fff;
  text-align: center;

  ${({ $cor }) =>
    $cor &&
    `
      border: 2px solid ${$cor};
      box-shadow: 0 0 0 2px ${$cor}33;
    `
  }

  transition: border 0.2s ease, box-shadow 0.2s ease;
`;

export const SelectStatus = ({
  $orcamento_id,
  $status_viagem,
  $data_inicio,
  $data_fim,
  $load,
  $setNewObj
}) => {

  const token = localStorage.getItem('token');

  const handleStatus = async (id, value) => {

    const body = {
      status_viagem: value
    };

    switch(value) {

      case 'reservado': {

        const bodyData = await ModalReservado();
        if (!bodyData) return;

        // ✅ AQUI entra SUA função (sem quebrar nada)
        const resultado = await verificarDisponibilidadeOnibus({
          api: api3001,
          token,
          onibus_id: bodyData.onibus_id,
          data_inicio: $data_inicio,
          data_fim: $data_fim,
          ignorar_id: id
        });

        if (!resultado.disponivel) {

          if (resultado.erro) {
            await Swal.fire("Erro", "Erro ao verificar disponibilidade", "error");
            return;
          }

          const mensagem = resultado.conflitos
            .map(c => c.mensagem)
            .join("<br><br>");

          await Swal.fire({
            icon: "error",
            title: "Ônibus indisponível",
            html: mensagem
          });

          return;
        }

        body.motorista = bodyData.motorista;
        body.onibus_id = bodyData.onibus_id;

        break;
      }

      case 'terceiro': {
        const bodyData = await ModalTerceiro();
        if (!bodyData) return;

        body.nome_terceiro = bodyData.nome_terceiro;
        break;
      }

      default: {

        if (value !== 'executado') {

          body.motorista = null;
          body.onibus_id = null;
          body.nome_terceiro = null;

          const confirm = await Swal.fire({
            title: 'Tem certeza que deseja alterar o status?',
            text: 'Informações de transporte podem ser perdidas',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
          });

          if (!confirm.isConfirmed) return;
        }

        break;
      }
    }

    try {

      await api3001.put(`/api/orcamento/${id}`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire("Sucesso", "Status atualizado com sucesso!", "success");

      $setNewObj?.(value);
      $load?.();

    } catch (err) {

      console.error(err);
      Swal.fire("Erro", "Erro ao atualizar status.", "error");

    }
  };

  return (
    <Select
      value={$status_viagem}
      onChange={(e) => handleStatus($orcamento_id, e.target.value)}
    >
      <option value="orcamento">Orçamento</option>
      <option value="prereservado">Pré-Reservado</option>
      <option value="reservado">Reservado</option>
      <option value="terceiro">Terceiro</option>
      <option value="cancelado">Cancelado</option>
      <option value="executado">Executado</option>
    </Select>
  );
};

const color = {
    verde: '#16a34a',
    vermelho: '#dc2626'
}

export const SelectPayment = ({$status_pagamento,$orcamento_id, $load, $setNewObj}) => {

    const token = localStorage.getItem('token');

    const handlePagamento = async (id, value) => {
    
    const body = {
      status_pagamento: value,
    };

    const confirm = await Swal.fire({
      title: 'Tem certeza que deseja alterar o status de pagamento?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    });
    if (!confirm.isConfirmed) return;
    
    const urlGetOrcamento = `/api/orcamento/${id}`

    try {
      await api3001.put(urlGetOrcamento, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      Swal.fire("Sucesso", "Status de pagamento atualizado com sucesso!", "success");
      $setNewObj?.(value);
      $load?.();
    } catch {
      Swal.fire("Erro", "Erro ao atualizar status de pagamento.", "error");
    }
    
  }

  return(
    <Select
        $cor={($status_pagamento === 'pendente') ? color.vermelho : color.verde}
        value={$status_pagamento}
        onChange={(e) => handlePagamento($orcamento_id, e.target.value)}
    >
        <option value="pendente">Pendente</option>
        <option value="pago">Pago</option>
    </Select>
  )
}

  